export enum SideNavigationTabCountType {
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  PRIMARY = 'primary'
}
